// extracted by mini-css-extract-plugin
export default {"fieldWrap":"DocumentNumberWithType_fieldWrap--lII","documentContainer":"DocumentNumberWithType_documentContainer--cma","marginTop":"DocumentNumberWithType_marginTop--rLk"};